<template>
    <div v-if="user" class="user-styles" :class="{ mobile: $store.getters.isMobile }">
        <div v-if="!tableOnly" class="title" v-html="$translate('IDEAL_TYPE')" />
        <Styles :styles="user.style" :gender="user.gender" />
        <div v-if="!tableOnly" class="text intro m-t-16" v-html="stylesIntro" />
        <div v-if="!tableOnly" class="text c-primary f-12 m-t-16" v-html="$translate('STYLES_NOT_SHOWN_FOR_USER')" />
    </div>
</template>
<script>
import Styles from '@/components/common/Styles'

export default {
    name: 'UserStyles',
    props: ['user', 'tableOnly'],
    components: {
        Styles,
    },
    computed: {
        stylesIntro() {
            if (!this.user.style) return

            return (this.user.style.intro || '').trim() || '-'
        },
    },
}
</script>

<style lang="scss" scoped>
.user-styles {
    &.mobile {
        .title {
            font-size: 18px;
        }
        .intro {
            color: $black;
            font-size: 15px;
        }
    }
}
</style>
